import { MapContainer, TileLayer, Marker, Popup, ZoomControl, useMap } from 'react-leaflet';
import L from 'leaflet';
import { useMemo, useEffect, useRef } from 'react';
import { IconButton } from '@shared/components';
import RecenterMap from './useMap';
import './MapItem.css';
import 'leaflet/dist/leaflet.css';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: new URL("leaflet/dist/images/marker-icon-2x.png", import.meta.url),
  iconUrl: new URL("leaflet/dist/images/marker-icon.png", import.meta.url),
  shadowUrl: new URL("leaflet/dist/images/marker-shadow.png", import.meta.url),
});

function MarkerItem({
  marker,
  popupContent,
  isSelected,
  onMarkerClick
}) {
  const markerRef = useRef(null);
  const map = useMap();

  useEffect(() => {
    if (isSelected && markerRef.current) {
      map.flyTo([marker.lat, marker.lng], map.getZoom());
      markerRef.current.openPopup();
    }
  }, [isSelected]);

  return (
    <Marker
      ref={markerRef}
      position={[marker.lat, marker.lng]}
      eventHandlers={{
        click: () => onMarkerClick(marker.id),
      }}
    >
      <Popup className='popup'>
        {popupContent ? (
          Object.entries(popupContent).map(([key, val]) => (
            <div style={{
              display: "inline-flex", justifyContent: "space-between",
              alignItems: "center", width: "fit-content", height: "fit-content", gap: "8px"
            }}>
              <span><strong>{key}</strong></span>
              <span><em>{val}</em></span>
            </div>
          ))) : (
          <></>
        )}
      </Popup>
    </Marker>
  );
};

function MapView({
  isActive = true,
  markers = [],
  zoom = 13,
  height = "400px",
  width = "100%",
  showPopups = true,
  selectedId,
  onMarkerClick,
  popupContent = null,
  selectedRow = null,
}) {
  const markerRefs = useRef([]);

  const center = useMemo(() => {
    if (!markers.length) return [0, 0];

    const n = markers.length;
    let sumLng = 0;
    let sumLat = 0;
    for (let i = 0; i < n; i++) {
      const p = markers[i];
      sumLat += p.lat;
      sumLng += p.lng;
    }

    return [sumLat / n, sumLng / n];
  }, [markers]);

  useEffect(() => {
    if (selectedRow !== null && markerRefs.current[selectedRow]) {
      markerRefs.current[selectedRow].openPopup();
    }
  }, [selectedRow]);

  return (
    <div style={{ height, width }}>
      <MapContainer
        center={center}
        zoom={zoom}
        scrollWheelZoom={true}
        zoomControl={false}
        style={{ height: "100%", width: "100%", zIndex: 1 }}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

        {markers.map((m) => (
          <MarkerItem
            key={m.id}
            marker={m}
            popupContent={popupContent}
            isSelected={selectedId === m.id}
            onMarkerClick={onMarkerClick}
          />
        ))}
        {/* <RecenterMap coords={selectedRow !== null ? markers[selectedRow] : center} /> */}
        <RecenterMap coords={markers} isActive={isActive} />
        <ZoomControl position="bottomright" />
      </MapContainer>
    </div>
  );
}

export default MapView;